import { render, staticRenderFns } from "./RichMenuDetail.vue?vue&type=template&id=0941066c&scoped=true&"
import script from "./RichMenuDetail.vue?vue&type=script&lang=js&"
export * from "./RichMenuDetail.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuDetail.vue?vue&type=style&index=0&id=0941066c&lang=scss&scoped=true&"
import style1 from "./RichMenuDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941066c",
  null
  
)

export default component.exports